// Dependencies
import React from 'react'
import { Grid, Typography, makeStyles } from '@material-ui/core'


// Styles
const useStyles = makeStyles(() => ({
   container: {
      display: 'flex',
      flexWrap: 'nowrap',
      background: 'white',
      borderBottom: '#0000000a 1px solid',
      padding: '15px 0px'
   },
   imgContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '168px',
      height: '106px'
   },
   img: {
      width: '100%',
      height: '100%'
   },
   descriptionContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-around',
      marginLeft: '14px',
      width: '69%'
   },
   title: {
      fontWeight: 'bold',
      color: '#43496A',
      fontSize: '14px'
   },
   description: {
      color: '#00000059',
      fontSize: '1em',
      height: '42px',
      overflow: 'hidden'
   },
   dateAndViews: {
      fontSize: '0.8em',
      marginRight: '4px'
   }
}))

const MutualSerNewItem = ({ imgSrc, title, description, date, views }) => {
   const classes = useStyles()

   return (
      <Grid container direction="row" className={classes.container}>
         <Grid className={classes.imgContainer}>
            <img
               className={classes.img}
               src={imgSrc}
               alt={'Imagen de la noticia'}
            />
         </Grid>
         <Grid className={classes.descriptionContainer}>
            <Grid>
               <Typography className={classes.title}>{title}</Typography>
            </Grid>
            <Grid>
               <Typography className={classes.description}>
                  {description}
               </Typography>
            </Grid>
            <Grid container direction="row">
               <Typography className={classes.dateAndViews}>{date}</Typography>
               <Typography className={classes.dateAndViews}>{views}</Typography>
            </Grid>
         </Grid>
      </Grid>
   )
}

export default MutualSerNewItem
